// import { Button } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import PrimaryButton from './PrimaryButton';


export const ButtonLogin = ({disabled, loading}) => {
  return (
    <div style={{textAlign: "center"}}>
      <PrimaryButton
        disabled={disabled || loading}
        endIcon={<LockIcon />}
        type="submit"
      >
        <span>Connexion</span> 
      </PrimaryButton>
    </div>
  );
};
